import React , {useEffect} from 'react'
import KindFoodCard from './KindFoodCard'
import Footer from './Footer'
import BeforeFooter from './BeforeFooter'

const Main = ({searchQuery , qty , setQty ,onAdd , increase , decrease}) => 
{
  // useEffect(() => {
  //   const themeBg = document.getElementById('theme-bg')
  //   const html = document.getElementsByTagName('html')
  //   console.log(html[0].classList == 'dark')
  //   if (html[0].classList =='dark') {
  //     themeBg.classList.add('dark-bg')
  //     themeBg.classList.remove('light-bg')
  //   } else {
  //     themeBg.classList.remove('dark-bg')
  //     themeBg.classList.add('light-bg')
  //   }
  // }, [])
  return (
    <section id='theme-bg' className=" light-bg pb-4  backdrop-blur-sm flex flex-col items-center dark:bg-gray-800 px-2 min-h-screen ">
        <h2 className='py-1 px-3 rounded-lg mt-3 text-xl font-bold bg-white dark:bg-slate-950 dark:text-white  ' >کافه رستوران سنتی کندوک</h2>
        <p className='bg-white dark:bg-slate-950  py-1 px-3 rounded-lg mt-2 dark:text-white' >کیفیت، اعتبار نام ماست</p>
    <KindFoodCard searchQuery={searchQuery} qty={qty} setQty={setQty} onAdd={onAdd} increase={increase} decrease={decrease} />
    
    </section>
  )
}

export default Main